export default container => {
  const requestButton = container.querySelector('[data-button-request]')

  const observer = new IntersectionObserver(entries => {
    entries.forEach(
      entry => {
        if (entry.isIntersecting) {
          if (requestButton) {
            requestButton.style.display = 'block'
          }

          observer.unobserve(entry.target)
        }
      },
      { treshold: 0.5 }
    )
  })

  container
    .querySelectorAll('.show-button')
    .forEach(section => observer.observe(section))
}
